import {MenuProvider, MenuButton} from '@ariakit/react'
import {Menu, MenuGroup, MenuItem} from '@components/ui/menu-atoms/MenuAtoms.tsx'
import {ArrowDownIcon, ArrowUpIcon, SwitchVertical01Icon, Trash01Icon, XCloseIcon} from '@components/ui/icon/Icon.tsx'
import {useTranslation} from '@/translations/i18n.tsx'
import {FC} from 'react'
import {TableOrder} from '@/types'
import {TableButton} from '../table-button/TableButton'

interface SortingMenuProps {
    columns: Array<{id: string; label: string}>
    order: TableOrder[]
    setOrder: (order: TableOrder[]) => void
}
export const SortingMenu: FC<SortingMenuProps> = ({columns, order, setOrder}) => {
    const {t} = useTranslation()

    return (
        <MenuProvider>
            <MenuButton
                render={
                    <TableButton isActive={order.length >= 1}>
                        <SwitchVertical01Icon />
                        {t('commons:sorting')}
                        {order.length >= 1 && ` (${order.length})`}
                    </TableButton>
                }
            />
            <Menu unmountOnHide>
                <MenuGroup>
                    {columns.map(column => {
                        const columnOrder = order.find(o => o.key == column.id)

                        return (
                            <MenuProvider key={column.id} placement="left">
                                <MenuButton showOnHover={false} render={<MenuItem key={column.id} />}>
                                    {!columnOrder ? (
                                        <span style={{width: 16}} />
                                    ) : columnOrder.direction == 'asc' ? (
                                        <ArrowUpIcon />
                                    ) : (
                                        <ArrowDownIcon />
                                    )}
                                    {column.label}
                                </MenuButton>
                                <Menu hideOnHoverOutside={false}>
                                    <MenuItem
                                        onClick={() => {
                                            if (columnOrder?.direction == 'asc') {
                                                setOrder(order.filter(o => o.key != column.id))
                                            } else if (columnOrder?.direction == 'desc') {
                                                setOrder(
                                                    order.map(o => (o.key == column.id ? {...o, direction: 'asc'} : o))
                                                )
                                            } else {
                                                setOrder([...order, {key: column.id, direction: 'asc'}])
                                            }
                                        }}
                                    >
                                        {columnOrder?.direction == 'asc' ? (
                                            <>
                                                <XCloseIcon />
                                                {t('commons:remove')}
                                            </>
                                        ) : (
                                            <>
                                                <ArrowUpIcon />
                                                {t('commons:ascending')}
                                            </>
                                        )}
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            if (columnOrder?.direction == 'desc') {
                                                setOrder(order.filter(o => o.key != column.id))
                                            } else if (columnOrder?.direction == 'asc') {
                                                setOrder(
                                                    order.map(o => (o.key == column.id ? {...o, direction: 'desc'} : o))
                                                )
                                            } else {
                                                setOrder([...order, {key: column.id, direction: 'desc'}])
                                            }
                                        }}
                                    >
                                        {columnOrder?.direction == 'desc' ? (
                                            <>
                                                <XCloseIcon />
                                                {t('commons:remove')}
                                            </>
                                        ) : (
                                            <>
                                                <ArrowDownIcon />
                                                {t('commons:descending')}
                                            </>
                                        )}
                                    </MenuItem>
                                </Menu>
                            </MenuProvider>
                        )
                    })}
                </MenuGroup>
                {order.length >= 1 && (
                    <MenuGroup>
                        <MenuItem onClick={() => setOrder([])}>
                            <Trash01Icon />
                            {t('commons:remove_sorting')}
                        </MenuItem>
                    </MenuGroup>
                )}
            </Menu>
        </MenuProvider>
    )
}
